module.exports = __webpack_public_path__ + "static/media/CamsNcp-image-design.262a4b45.png";